import { render, staticRenderFns } from "./AnnotationsContainer.vue?vue&type=template&id=118edc0c"
import script from "./AnnotationsContainer.vue?vue&type=script&lang=js"
export * from "./AnnotationsContainer.vue?vue&type=script&lang=js"
import style0 from "./AnnotationsContainer.vue?vue&type=style&index=0&id=118edc0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports